<template>
    <div>
        <b-field label="Etiquetar productos a la publicacion:">
            <b-taginput
            v-model="tagsSelected"
            autocomplete
            rounded
            field="title"
            :data="productOptions"
            @typing="searchProducts"
            @add="updateMainTags"
            @remove="updateMainTags"
            ref="taginput"
            icon="label"
            >
                <template slot-scope="props">
                <strong>{{props.option.code}}</strong> - {{props.option.title}}
                </template>
                <template slot="empty">
                    No encontramos ningun producto...
                </template>
            </b-taginput>
        </b-field>
        <div class="columns is-multiline">
            <div v-for="tag in tagsSelected" :key="tag.id" class="column is-half-mobile is-one-fifth-tablet is-one-quarter-desktop">
                <div class="card">
                    <div class="card-image has-text-centered">
                        <img :src="tag.getImage" alt="imagen-producto">
                    </div>
                    <div class="card-content">
                        <div class="content product-content">
                            <p class="has-text-weight-semibold">{{tag.title}}</p>
                            <div class="price has-text-centered">
                                <p style=" text-decoration: line-through; color:#333;" v-if="tag.status=='O'">
                                    {{tag.currencySymbol}} {{tag.compareAt}}
                                </p>
                                <p class="has-text-custom">{{tag.currencySymbol}} {{tag.price}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getHandler } from '../../../../services/http'
export default {
    props:{
        productSearch:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            tagsSelected:[],
            productOptions:[]
        }
    },
    methods:{
        async searchProducts(text){
            var url = this.productSearch + `?search=${text}`
            var resp = await getHandler(url, {error:false, success:false})
            console.log(resp)
            this.productOptions = resp.results
        },
        updateMainTags(){
            this.$emit("updateCreationTags", this.tagsSelected)
        }
    }
}
</script>